/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Firebase from 'firebase/app';

import { Client } from 'fierry/flux';

import State from 'shared/client/auth/state';


export default new Client ([ State ], class
{
  constructor ([ state, dispatch ])
  {
    this.state = state;
    this.dispatch = dispatch;
  }


  logout ()
  {
    Firebase.auth().signOut();
  }


  isLoggedIn ()
  {
    const { login, query } = this.state;

    return login && !query;
  }


  isLoggedOut ()
  {
    const { login, query } = this.state;

    return !login && !query;
  }


  isQueryComplete ()
  {
    return !this.state.query;
  }


  getToken ()
  {
    return this.state.token;
  }


});
